<template>
  <div id="about">
    <div class="about center">
      <h4 class="cyan-text text-darken-1">運営者情報</h4>
      <img class="katonobologo" src="@/assets/katonobo.png">
      <p>katonobo</p>
      <p><a href="https://twitter.com/katonobo1">ツイッター</a></p>
      <p><a href="http://www.katonobo.com/">ブログ</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data(){
    return{

    }
  }
}
</script>

<style>
.about{
 margin-top:100px;
}
.katonobologo {
  width: 200px;
  height: 200px;
  border-radius: 20px 20px 20px 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/info/About.vue